import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    return { isDarkMode: false, toggleTheme: () => {} };
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('taxfilepro-theme');
    if (saved) return saved === 'dark';
    // Check system preference
    return window.matchMedia?.('(prefers-color-scheme: dark)')?.matches || false;
  });

  const toggleTheme = useCallback(() => {
    setIsDarkMode(prev => !prev);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    if (isDarkMode) {
      root.setAttribute('data-theme', 'dark');
      document.body.classList.add('dark-mode');
      document.body.classList.remove('light-mode');
    } else {
      root.setAttribute('data-theme', 'light');
      document.body.classList.add('light-mode');
      document.body.classList.remove('dark-mode');
    }
    localStorage.setItem('taxfilepro-theme', isDarkMode ? 'dark' : 'light');

    // Update PWA status bar color to match theme
    const themeColorMetas = document.querySelectorAll('meta[name="theme-color"]');
    const pwaColor = isDarkMode ? '#0f0f1a' : '#0a2540';
    themeColorMetas.forEach(meta => { meta.setAttribute('content', pwaColor); });
  }, [isDarkMode]);

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
